import { render, staticRenderFns } from "./postEdit.vue?vue&type=template&id=58f1b9ba&scoped=true&"
import script from "./postEdit.vue?vue&type=script&lang=js&"
export * from "./postEdit.vue?vue&type=script&lang=js&"
import style0 from "./postEdit.vue?vue&type=style&index=0&id=58f1b9ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1b9ba",
  null
  
)

export default component.exports